@if (sustainableType) {
  <button
    class="btn btn-icon img me-2"
    (click)="showDescription()"
    [title]="label"
    [ngClass]="{ 'use-border': showBorder }"
  >
    <img [src]="icon" [alt]="label" />
  </button>
}
